import request from "../request";
// 登录接口
export function login(data) {
  return request({
    url: "/login",
    method: "post",
    data,
  });
}
// 获取产品信息接口
export function ProductData(data) {
  return request({
    url: "/ld/ksProductData/getListDataByUserCode",
    method: "post",
    data,
  });
}
// 账户信息
export function AccountData(data) {
  return request({
    url: "/ld/ksAdvertiserDetails/getListData",
    method: "post",
    data,
  });
}

// 数据分析 总数据
export function OverviewData(data) {
  return request({
    url: "/ld/ksSupplementOrderRealtimeDataCopy/getListDataCount",
    method: "post",
    data,
  });
}

// 数据分析列表
export function AnalysisData(data) {
  return request({
    url: "/ld/ksSupplementOrderRealtimeDataCopy/getListData",
    method: "post",
    data,
  });
}

// 趋势图
export function TrendChart(data) {
  return request({
    url: "/ld/ksSupplementOrderRealtimeData/getListDataLineChart",
    method: "post",
    data,
  });
}

// 卡片数据 -- 产品数据看板
export function ProductDataDashboard(data) {
  return request({
    url: "/ld/ksSupplementOrderRealtimeDataCopy/getImmediatelyDataList",
    method: "post",
    data,
  });
}
// 卡片数据 -- 产品对应图表
export function ObtainChartData(data) {
  return request({
    url: "/ld/ksSupplementOrderRealtimeDataCopy/getChartImmediatelyDataList",
    method: "post",
    data,
    headers: {
      "Content-Type": "application/json", // 设置为JSON格式
    },
  });
}

// 添加产品到卡片接口
export function operationCardProduct(data) {
  return request({
    url: "/ld/ksUserProductData/saveKsUserProductData",
    method: "post",
    data,
    headers: {
      "Content-Type": "application/json", // 设置为JSON格式
    },
  });
}

// 卡片 修改排序/置顶字段
export function reviseCardProduct(data) {
  return request({
    url: "/ld/ksUserProductData/addKsUserProductData",
    method: "post",
    data,
    headers: {
      "Content-Type": "application/json",
    },
  });
}

// 移除卡片
export function detachCardProduct(data) {
  return request({
    url: "/ld/ksUserProductData/delete",
    method: "post",
    data,
  });
}

export default {
  login,
  ProductData,
  AccountData,
  OverviewData,
  AnalysisData,
  TrendChart,
  ProductDataDashboard,
  ObtainChartData,
  reviseCardProduct,
  detachCardProduct,
  operationCardProduct,
};
